var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"table-row-icon",class:{'table': _vm.tableAction, 'custom-icon-small': _vm.small, 'custom-icon-large': !_vm.small},attrs:{"alt":_vm.iconName,"src":_vm.src}})}
var staticRenderFns = []

export { render, staticRenderFns }